/*
 * This code is the intellectual property of Bulb Inc. and other software publishers.
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/
import { Component, Input } from '@angular/core';
import { SvgIconRegistry } from '@ngneat/svg-icon';
import { fasEyeIcon } from 'IconLibrary/fontawesome/solid/eye';
import { faExclamationCircleIcon } from 'IconLibrary/fontawesome/regular/exclamation-circle';
import { faArrowAltCircleUpIcon } from 'IconLibrary/fontawesome/regular/arrow-alt-circle-up';
import { BlockTileFooterData, BlockTileFooterIcons } from '../tiles';

/**
 * This component is the block-tile footer used on Pages and Collections to display information
 * about the current unit. This component utilizes the tiles-footer-icon component to display
 * different icons depending on certain situations
 */
@Component({
  selector: 'bulb-tiles-footer',
  templateUrl: './tiles-footer.component.html',
  styleUrls: ['./tiles-footer.component.scss'],
  standalone: false,
})
export class TilesFooterComponent {
  /**
   * Data passed in from AJS blockCtrl to determine different template states
   */
  @Input() tileFooterData: BlockTileFooterData;

  /**
   * Data passed in from blockCtrl scaffolding out the icons to display in this components
   * template.
   */
  @Input() tileFooterIcons: Array<BlockTileFooterIcons>;

  constructor(private registry: SvgIconRegistry) {
    this.registry.register([
      fasEyeIcon,
      faExclamationCircleIcon,
      faArrowAltCircleUpIcon,
    ]);
  }

  /**
   * Returns true if at least one menu item is visible.
   *
   * A menu item is considered visible when its `hidden` property is false.
   * Used to determine whether the footer menu should be rendered.
   */
  get hasVisibleMenuItems(): boolean {
    return this.tileFooterData?.menuItems?.some((item) => !item.hidden);
  }
}
